<template>
  <v-app>
    <v-app-bar
      dense
      fixed
      flat
      style="
        font-family:
          'Avantgarde', 'TeX Gyre Adventor', 'URW Gothic L', sans-serif;
        background: black;
      "
      min-height="45px"
      max-height="45px"
      id="topLogIn"
    >
      <!-- style="font-family: 'Avantgarde', 'TeX Gyre Adventor', 'URW Gothic L', sans-serif" -->
      <!-- style="font-family: 'Montserrat', sans-serif" -->
      <v-toolbar-title
        @click="$router.push('/main-cluster').catch(() => {})"
        style="cursor: pointer"
      >
        <v-card
          class="transparent"
          min-height="40px"
          max-height="40px"
          min-width="90px"
          max-width="90px"
        >
          <v-img src="AGTSLogo.png"></v-img> </v-card
      ></v-toolbar-title>
      <v-spacer></v-spacer>
      <v-toolbar-items
        v-if="
          this.isLoggedIn &&
          this.$route.path != '/login' &&
          this.$route.path != '/forgotpassword'
        "
      >
        <v-btn text block @click="logOut"> logout </v-btn>
      </v-toolbar-items>
      <v-toolbar-items v-if="!this.isLoggedIn">
        <v-btn text block to="login"> login </v-btn>
      </v-toolbar-items>
    </v-app-bar>
    <GlobalSnackbar />
    <v-main>
      <router-view />
    </v-main>
  </v-app>
</template>
<script>
import { Auth } from 'aws-amplify'
import * as Sentry from '@sentry/vue'
import GlobalSnackbar from '@/components/GlobalSnackbar.vue'

export default {
  name: 'AuthLayout',
  components: {
    GlobalSnackbar,
  },
  computed: {
    isLoggedIn: async function () {
      try {
        await Auth.currentAuthenticatedUser()
        return true
      } catch {
        return false
      }
    },
  },
  methods: {
    logOut: async function () {
      try {
        await Auth.currentAuthenticatedUser()
        await Auth.signOut({ global: true })
      } catch {
        // User is not logged in, skip signout
      }

      Sentry.setUser(null)
      localStorage.clear()

      this.$router.push('/login').catch(() => {})
    },
  },
}
</script>
<style>
* {
  box-sizing: border-box;
}
html {
  height: 100%;
}
body {
  width: 100%;
  height: 100%;
  margin: 0;
  padding: 0;
}
#topLogIn >>> .v-toolbar__content {
  min-height: 40px;
  max-height: 40px;
}
</style>
